module.exports = __webpack_public_path__ + "media/images/ecommerce/product_03-c38d94987eb568b35649aca0235991a4.svg";